import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { CatalogosComponent } from './catalogos/catalogos.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { AltaPlanesComponent } from './alta-planes/alta-planes.component';

const routes: Routes = [
  {
    path: 'app/administrador-gestion',
    component: ContenedorComponent,
    children: [
      {path: 'catalogos', component: CatalogosComponent, canActivate: [authGuardSubmodule]},
      {path: 'alta-planes', component: AltaPlanesComponent, canActivate: [authGuardSubmodule]},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministradorGestionRoutingModule { }
